/**
 * One entry of the pre-recorded voicemail catalogue held at
 * `welby_configuration/voicemail/messages/catalogue`.
 *
 * The audio lives in S3 and only its key is stored. The web app never fetches it — the call
 * processor presigns and plays it — so the key is here purely to keep one shape for the document.
 * There is no per-entry bucket: the processor always reads from its own, which is what makes the
 * prefix it enforces mean anything.
 */
export interface VoicemailMessage {
  /** Stable id sent with the call as the staff member's selection. */
  id: string;

  /** Human label shown in the call dialog, e.g. "RPM - Program message". */
  label: string;

  /** S3 object key of the audio. */
  s3Key: string;

  /** Entries are hidden from the select while this is false. */
  isActive: boolean;

  /** Ascending display order. */
  order?: number;
}

/**
 * Selections that are not a catalogue entry.
 *
 * These must stay in step with the call processor's own `VoicemailSelection`, which is what
 * actually acts on the value when the mailbox picks up.
 */
export const VOICEMAIL_SELECTION = {
  /** Stay on the line and speak the message. The default, and what happened before this existed. */
  LIVE: 'live',

  /** Hang up at the beep without leaving anything. */
  NONE: 'none',
} as const;

/** Shape of the `welby_configuration/voicemail/messages/catalogue` document. */
export interface VoicemailMessageCatalogue {
  messages?: VoicemailMessage[];
}
